import React, { FC } from "react"
import "./Button.scss";
import { ReactSVG } from "react-svg";

export enum EButtonType {
    PRIMARY,
    SECONDARY
}

export enum EButtonSize {
    NORMAL,
    SMALL
}

interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    text?: string,
    buttonType?: EButtonType
    size?: EButtonSize
    iconLeft?: string
    iconRight?: string
    iconSize?: number
}

const Button: FC<IButtonProps> = ({
    text,
    className,
    buttonType,
    size,
    iconLeft,
    iconRight,
    iconSize,
    style,
    onClick
}, props) => {
    const getClassName = (): string => {
        switch (buttonType) {
            case EButtonType.PRIMARY:
                return "primary-btn"
            case EButtonType.SECONDARY:
                return "secondary-btn"
            default:
                return "primary-btn"
        }
    }

    const getSize = (): string => {
        switch (size) {
            case EButtonSize.NORMAL:
                return "btn-size-normal"
            case EButtonSize.SMALL:
                return "btn-size-small"
            default:
                return "btn-size-normal"
        }
    }

    return (
        <button
            {...props}
            className={`${getClassName()} ${getSize()} ${className}`}
            style={style}
            onClick={onClick}
        >
            {iconLeft && <ReactSVG className="btn-icon btn-icon-left" src={iconLeft} style={{ width: iconSize, height: iconSize }} />}
            {text}
            {iconRight && <ReactSVG className="btn-icon btn-icon-right" src={iconRight} style={{ width: iconSize, height: iconSize }} />}
        </button>    
    )
}

export default Button